module.exports = __webpack_public_path__ + "img/neo-tag-poweredby.49a0f57d.png";